import React from 'react';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import BeautyTechVirtualEventDetail from './async';

export default [
  <Route
    key="/business/beauty-tech-forum-master-class/detail/:sessionId?"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Master Series',
            item: '/business/beauty-tech-forum-master-class/detail',
          },
        ]}
      />
    }
  >
    <Route
      path="business/beauty-tech-forum-master-class/detail/:sessionId?"
      element={<BeautyTechVirtualEventDetail />}
    />
  </Route>,
  <Route
    key="/business/beauty-tech-forum-master-class/detail/:sessionId?/:thankyou?"
    element={<DefaultBusinessLayout />}
  >
    <Route
      path="business/beauty-tech-forum-master-class/detail/:sessionId?/:thankyou?"
      element={<BeautyTechVirtualEventDetail />}
    />
  </Route>,
  <Route
    key="/business/global-beauty-tech-forum/detail/:sessionId?"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'GBTF',
            item: '/business/global-beauty-tech-forum/detail',
          },
        ]}
      />
    }
  >
    <Route
      path="business/global-beauty-tech-forum/detail/:sessionId?"
      element={<BeautyTechVirtualEventDetail />}
    />
  </Route>,
];
